import axios from "axios";
import { toast } from "sonner";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const img = (u) => (u && u.startsWith("/api/") ? `${BACKEND}${u}` : u || "");

export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => String(x.msg || "").replace(/^Value error, /, "")).join(", ");
  return fallback;
};

export const usd = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;
export const ugx = (n) => `UGX ${Number(n || 0).toLocaleString()}`;
export const money = (cur, n) => (n === "" || n == null ? "" : `${cur} ${Number(n).toLocaleString()}`);
export const fmtDate = (s) => (s ? new Date(s).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "—");
export const digits = (s) => (s || "").replace(/\D/g, "");
const intl = (phone) => { const d = digits(phone); return d.startsWith("0") ? `256${d.slice(1)}` : d; };
export const waLink = (phone, text = "") => `https://wa.me/${intl(phone)}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const guestUrl = (slug) => `${window.location.origin}/p/${slug}`;
export const khUrl = (code) => `${window.location.origin}/k/${code}`;

export async function downloadFile(path, filename) {
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  } catch {
    toast.error("Download failed. Please try again.");
  }
}

export const downloadReceipt = (cid, ref) => downloadFile(`/checkins/${cid}/receipt?base=${encodeURIComponent(window.location.origin)}`, `receipt-${ref}.pdf`);

export const STATUS_META = {
  owner: { label: "Owner", cls: "bg-[#151312] text-white" },
  active: { label: "Paid", cls: "bg-[#E3EEE2] text-[#3E6B3C]" },
  trial: { label: "Free trial", cls: "bg-[#FBEBD2] text-[#8A5A12]" },
  pastdue: { label: "Payment due", cls: "bg-[#F9DED4] text-[#A6431F]" },
  expired: { label: "Paused", cls: "bg-[#F4D4D4] text-[#9B2C2C]" },
  suspended: { label: "Suspended", cls: "bg-[#E8E4DF] text-[#4A4440]" },
};
